import { Pivot } from 'api';
import { getSessionId as _getSessionId, setSessionId as _setSessionId } from 'data/storage';

export const getSessionId = async (force: boolean = false) => {
  let sessionId = _getSessionId();
  if (!sessionId || force) {
    const res = await Pivot.getSessionId().toPromise();
    console.log('getSessionId', res);
    sessionId = res.sessionId;
    _setSessionId(sessionId);
  }
  if (!sessionId) {
    throw new Error('getSessionId error');
  }
  return sessionId as string;
};
